import React, {useEffect, useState} from "react";
import {IoMdSearch} from "react-icons/io";
import {
    Input, Button,
    Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, useDisclosure
} from "@nextui-org/react";

import DeaneriesBlock from "@/components/shared/deaneries-block";
import Select, {AriaOnFocus} from 'react-select';


import ClergiesBlock from "@/components/shared/clergies-block";
import {POSITIONS} from '@/configuration/static-data-provider';
import TuneFilterComponent from '../../public/icons/tuneFilter.js';
import Head from "next/head";
import {GlobalSettings} from "@/configuration/global-settings";
import imgStatic from "@/public/webp/chanh-toa.webp";
import {usePathname} from "next/navigation";
import {getPriest} from "@/services/home-service";


const CustomSelect = ({params, actions}) => {
    const [scaleCustom, setScaleCustom] = useState('false');
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const onMenuOpen = () => {
        setIsMenuOpen(true);
        setScaleCustom('h-[200px]');
    };
    const onMenuClose = () => {
        setIsMenuOpen(false);
        setScaleCustom('');
    };
    const handleChange = (selectedOption) => {
        selectedOption ? actions.setPosition({
            value: selectedOption.value,
            label: selectedOption.label
        }) : actions.setPosition('')
    };

    return (
        <div className="">
            <div className={scaleCustom}>
                <label className="font-bold block mb-3" id="aria-deanery-label" htmlFor="aria-deanery-input">Chức
                    vụ</label>

                <Select
                    isClearable
                    name="aria-live-color"
                    onChange={handleChange}
                    onMenuOpen={onMenuOpen}
                    options={params.options}
                    onMenuClose={onMenuClose}
                    hideSelectedOptions={true}
                    inputId="aria-deanery-input"
                    aria-labelledby="aria-deanery-label"
                    defaultValue={params.currentPosition}
                    placeholder="Vui lòng chọn chức vụ..."
                />
            </div>
        </div>
    );
};

export default function Clergies() {
    const pathname = usePathname();
    const [clergyName, setClergyName] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [clergies, setClergies] = useState({total: 0});
    const [deaneries, setDeaneries] = useState({total: 0});
    const [currentDeanery, setCurrentDeanery] = useState('');

    let filterChurches = async () => {
        const urlSearchParams = new URLSearchParams(window.location.search);
        if (urlSearchParams.get('page') && urlSearchParams.get('page') !== currentPage) {
            setCurrentPage(urlSearchParams.get('page'))
        }

        let payload = {
            page: currentPage,
            clergyName: clergyName,
            deaneryId: currentDeanery
        }

        const response = await getPriest(payload);

        setClergies(response);
    }

    useEffect(() => {
        filterChurches();
    }, [currentDeanery, clergyName, currentPage]);

    return <>
        <Head>
            <title>GIÁO PHẬN PHÚ CƯỜNG - LINH MỤC ĐOÀN</title>
            <meta name="description" content="Chuyên trang truyền thông Giáo Phận Phú Cường"/>
            <meta name="keywords"
                  content="Giáo Phận Phú Cường, giao phan phu cuong, linh mục, linh mục đoàn, phú cường"/>

            <meta property="og:url" content={`${GlobalSettings.Settings.WebServer}/${pathname}`}/>
            <meta property="og:image"
                  content={imgStatic}/>
            <meta property="og:title" content="GIÁO PHẬN PHÚ CƯỜNG - LINH MỤC ĐOÀN"/>

            <meta name="twitter:card" content="summary_large_image"/>
            <meta name="twitter:title" content="GIÁO PHẬN PHÚ CƯỜNG - LINH MỤC ĐOÀN"/>
            <meta name="twitter:description" content="Chuyên trang truyền thông Giáo Phận Phú Cường"/>
            <meta name="twitter:image" content={imgStatic}/>
        </Head>

        {/* Search Clergy */}
        <div className="text-center pt-5">
            <h2 className="text-primary text-4xl font-bold py-5">TRA CỨU LINH MỤC</h2>

            <div className="mb-7">
                <Input
                    radius="lg"
                    classNames={{
                        input: [
                            "h-11",
                            "bg-white",
                            "text-black/90 dark:text-white/90",
                            "placeholder:text-default-700/50 dark:placeholder:text-white/60",
                        ],
                        innerWrapper: "bg-transparent",
                        inputWrapper: [
                            "shadow-xl",
                            "bg-white",
                            "dark:bg-default/60",
                            "backdrop-blur-xl",
                            "backdrop-saturate-200",
                            "hover:bg-default-200/70",
                            "dark:hover:bg-default/70",
                            "group-data-[focused=true]:bg-default-200/50",
                            "dark:group-data-[focused=true]:bg-default/60",
                            "!cursor-text",
                        ],
                    }}
                    startContent={<IoMdSearch className="text-black ml-5"/>}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            setClergyName(e.target.value);
                        }
                    }}
                    onChange={(e) => {
                        if (e.target.value.length === 0) {
                            setClergyName(e.target.value)
                        }
                    }}
                />
            </div>
        </div>

        {/* List Card Deanery */}
        <DeaneriesBlock
            params={{
                currentDeanery: currentDeanery
            }}
            actions={{
                setCurrentPage: setCurrentPage,
                setDeaneriesData: setDeaneries,
                setCurrentDeanery: setCurrentDeanery
            }}
        />

        {/* List Clergy */}
        <div className="pt-5">
            <ClergiesBlock clergies={clergies} isPagination={true} actions={{setCurrentPage: setCurrentPage}}/>
        </div>
    </>
}
